// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1wspS","upload":"Small_upload__1ewE2","imageWrap":"Small_imageWrap__12EtX","removeBtn":"Small_removeBtn__2ZPx2"};